import React, { useState, useEffect } from 'react';
import GenericModal from '@ui-components/Modal/GenericModal';
import GenericButton from '@ui-components/Button/GenericButton';
import { updateReflectorLicense } from '../../Reflector/request/request';
import { useAuth0 } from '@auth0/auth0-react';
import GenericInput from '@ui-components/Input/GenericInput';

interface License {
  id: number;
  description: string;
}

interface EditLicenseModalProps {
  isOpen: boolean;
  onClose: () => void;
  license: License | null;
  onLicenseUpdated: () => void;
}

const EditLicenseModal: React.FC<EditLicenseModalProps> = ({ isOpen, onClose, license, onLicenseUpdated }) => {
  const [description, setDescription] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    if (license) {
      setDescription(license.description);
    }
  }, [license]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!license) return;

    setIsLoading(true);
    setError(null);

    try {
      const token = await getAccessTokenSilently();
      await updateReflectorLicense(token, license.id, { description });
      onLicenseUpdated();
      onClose();
    } catch (err) {
      setError('Failed to update license. Please try again.');
      console.error('Error updating license:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <GenericModal isOpen={isOpen} onClose={onClose}>
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-xl font-semibold text-semantic-text-secondary">Edit License</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <GenericInput
              label="Description"
              value={description}
              onChange={setDescription}
              required
            />
          </div>
          {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
          <div className="flex justify-end">
            <GenericButton
              label="Save"
              type="submit"
              variant="brand"
              size="md"
              loading={isLoading}
              disabled={isLoading}
            />
          </div>
        </form>
    </GenericModal>
  );
};

export default EditLicenseModal; 